import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ImageEditor from "components/library/ImageEditor";
import TakeoverPanel from "components/library/TakeoverPanel";

import { updateUserImageAsync } from "settings/actions/users";

import styles from "./UserImageEditor.css";

class UserImageEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: props.match.params.username || "me",
    };

    this.onSuccess = this._onSuccess.bind(this);
  }

  _onSuccess(image) {
    return this.props.updateUserImageAsync(this.state.username, image);
  }

  render() {
    return (
      <TakeoverPanel containerStyle={styles.container}>
        <ImageEditor
          {...this.props}
          redirectTo={`/settings/user/${this.state.username}/`}
          onSuccess={this.onSuccess}
          skipMeta={true}
          hideCropNames={true}
          imageRequirements={{
            minWidth: 328,
            minHeight: 328,
          }}
          cropRequirements={{
            "1x1": {
              minWidth: 328,
              minHeight: 328,
            },
          }}
        />
      </TakeoverPanel>
    );
  }
}

UserImageEditor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string,
    }),
  }),
  updateUserImageAsync: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  updateUserImageAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserImageEditor);
